import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import assignments from './modules/assignments';
import checkin from './modules/checkin';
import confirm from './modules/confirm';
import dashboard from './modules/dashboard';
import externals from './modules/externals';
import header from './modules/header';
import navigation from './modules/navigation';
import popup from './modules/popup';
import progressBar from './modules/progressBar';
import user from './modules/user';

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules: {
        assignments,
        checkin,
        confirm,
        dashboard,
        externals,
        header,
        navigation,
        popup,
        progressBar,
        user,
    },
});
